import React from "react";

// form & validsation
import * as yup from "yup";
import { FormError, FormDropDown, FormLabel } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const schema = yup.object().shape({
  relationship: yup.object().shape({
    current_arrangements: yup.string().required("You must provide a value"),
  }),
});

export function Step16({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  const handleData = (values) => {
    const copy_data = Object.assign({}, store.relationship);
    const merger_current_values = { ...copy_data, ...values.relationship };
    const mergeToStore = { ...store, relationship: merger_current_values };
    onSubmit(mergeToStore);
  };
  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`relationship.current_arrangements`}
            className={customClasses.questionText}
            error={errors?.relationship?.current_arrangements?.message}
          >
            What are your current living arrangements?
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Make a selection"
              id={`relationship.current_arrangements`}
              type="text"
              name={`relationship.current_arrangements`}
              error={errors?.relationship?.current_arrangements?.message}
              data={[
                `Still living together`,
                `I moved out`,
                `${
                  store?.user_details?.partner_first_name
                    ? store?.user_details?.partner_first_name
                    : "My ex-partner"
                } moved out`,
                `It's more complicated`,
              ]}
              setValue={setValue}
              register={register}
              value={watch()?.relationship.current_arrangements}
            />
          </article>
        </section>
        <FormError error={errors?.ex_if_post_respond?.message} />
      </section>
    </form>
  );
}
